import { createActionCreator } from '../../lib/Actions/factory';

const createAction = createActionCreator('REDUX_STATE');

export const SET_REDUX_STATE = createAction('SET_REDUX_STATE', data => data);
export const UNSET_REDUX_STATE = createAction('UNSET_REDUX_STATE', data => data);
